package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "it")
val ItStrings = Strings(
    analyzer = "Analizzatore",
    appreciationOverview = "Panoramica dell'apprezzamento",
    chartLegendInterest = "Interessi",
    chartLegendPrincipal = "Capitale",
    chartXaxisMonths = "Mesi",
    chartYaxisPayment = "Pagamento",
    code = "it",
    costOfCredit = "Costo del Credito",
    creditDealAnalyzerDescription = "Inserisci i dettagli del tuo prestito per ricevere un'analisi completa della tua offerta di credito. Il nostro analizzatore valuta le metriche chiave per aiutarti a capire il vero costo del tuo prestito e prendere una decisione informata.",
    detailsGoodRateLongTerm = "Buon tasso ma il lungo termine comporta un costo totale elevato.",
    detailsHighApr = "TAEG alto. ",
    detailsHighInterestCost = "Costo totale degli interessi elevato.",
    detailsHighRateShortTerm = "Tasso alto ma il breve termine mantiene basso il costo totale.",
    detailsLowApr = "TAEG basso. ",
    detailsLowInterestCost = "Costo totale degli interessi basso.",
    discountsTradeIn = "Sconti / Permuta",
    displayName = "Italiano",
    distribution = "Distribuzione",
    downPayment = "Acconto",
    effectiveApr = "TAEG",
    headerBalance = "Saldo",
    headerDate = "Data",
    headerInterest = "Interessi",
    headerMonth = "#",
    headerPayment = "Pagamento",
    headerPrincipal = "Capitale",
    hideDetails = "Nascondi Dettagli",
    interest = "Interessi",
    invalidData = "Dati Non Validi",
    loanAmountSupportingText = "L'importo totale del prestito, inclusi eventuali costi aggiuntivi.",
    loanDetails = "Dettagli del Prestito",
    paymentSupportingText = "Il tuo pagamento mensile stimato.",
    paymentComposition = "Composizione del Pagamento",
    percentSymbol = "%",
    principal = "Capitale",
    ratingBad = "Cattivo Affare",
    ratingExcellent = "Affare Eccellente",
    ratingFair = "Affare Equo",
    ratingGood = "Buon Affare",
    ratingPoor = "Affare Scadente",
    schedule = "Piano di Ammortamento",
    showDetails = "Mostra Dettagli",
    summaryBad = "Molto sfavorevole, evitare se possibile.",
    summaryExcellent = "Condizioni finanziarie eccellenti.",
    summaryFair = "Condizioni eque, considerare la negoziazione.",
    summaryGood = "Buone condizioni, standard per il mercato.",
    summaryPoor = "Condizioni scadenti, costo o tasso elevato.",
    totalPaid = "Totale Pagato",
    lockTaxRate = "Blocca Aliquota Fiscale",
    unlockTaxRate = "Sblocca Aliquota Fiscale",
    currencySymbol = "€",
    currency = "Valuta",
    totalCreditAmount = "Importo Totale del Credito",
    taxAmount = "Importo Tassa/Detrazione",
    netAmountDisbursed = "Importo Netto Erogato",
    years = "Anni",
    loanTermTotalMonths = "Durata del Prestito (Mesi)",
    monthlyInstallment = "Rata Mensile",
    principalInstallment = "Rata Capitale",
    otherFees = "Altre Commissioni",
    insuranceCost = "Premio Assicurativo",
    aprc = "Tasso Annuo Effettivo Globale (TAEG)",
    totalAmountPayable = "Importo Totale da Pagare",
    prepaidFeeFixed = "Commissione di Istruttoria (Importo Fisso)",
    prepaidFeePercentage = "Commissione di Istruttoria (Percentuale)",
    months = "Mesi",
    description = "Questo analizzatore ti aiuta a valutare se un'offerta di prestito è favorevole per te. A differenza dei calcolatori standard, non richiede l'inserimento di un tasso di interesse. Invece, calcola il TAEG e il costo totale del credito in base ai pagamenti e alle commissioni, fornendo una valutazione dell'affare e grafici dettagliati.",
    agree = "Accetto",
    information = "Informazioni",
    errorCalculationOverflow = "Il TAEG è troppo alto, overflow di calcolo.",
    errorTotalPaymentIsLessThanLoanAmount = "L'importo ricevuto è inferiore all'importo del prestito.",
    errorDivisionByZero = "Divisione per zero",
    errorNegativeResult = "Risultato negativo",
    errorRateTooHigh = "Il tasso è troppo alto",
    errorCalculation = "Si prega di inserire dati corretti",
    close = "Chiudi",

    hi = "Ciao",
    guest = "Ospite",
    account = "Account",
    signInWithGoogle = "Accedi con Google",
    signOut = "Esci",
    settings = "Impostazioni",
    about = "Informazioni",
    privacyPolicy = "Informativa sulla privacy",
    termsOfService = "Termini di servizio",
    language = "Lingua",

    theme = "Tema",
    light = "Chiaro",
    dark = "Scuro",
    system = "Sistema",
    toggleExpand = "Espandi/Comprimi",
)
